/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Currentuniversity1Inputs */

const en__field_currentuniversity1 = /** @type {(inputs: _Field_Currentuniversity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current university`)
};

const de__field_currentuniversity1 = /** @type {(inputs: _Field_Currentuniversity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derzeitige Hochschule`)
};

/**
* | output |
* | --- |
* | "Current university" |
*
* @param {_Field_Currentuniversity1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_currentuniversity1 = /** @type {((inputs?: _Field_Currentuniversity1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Currentuniversity1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_currentuniversity1(inputs)
	return de__field_currentuniversity1(inputs)
});
export { _field_currentuniversity1 as "_field_currentUniversity" }